import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {FC} from 'react'
import {Container} from 'src/common/Container'
import {BentoCard} from '../components/BentoCard'
import {BentoGridHeader} from '../components/BentoGridHeader'

type DefaultVariationProps = {
  slice: Content.BentoGridSliceDefault
}

/**
 * Default variation of BentoGrid
 * Features rich cards with images, Lottie animations, quotes, and flexible layouts
 */
export const BentoGridDefaultVariation: FC<DefaultVariationProps> = ({slice}) => {
  const {tag, heading, description, cards, left_alignment} = slice.primary

  return (
    <Container
      data-slice-type="bento_grid"
      data-slice-variation="default"
      className="flex flex-col items-center !py-8 px-5 md:!py-10 md:px-10 lg:px-5 xl:px-0"
      backgroundColor="Grey/100"
    >
      <div className="mx-auto w-full max-w-[1200px]">
        <BentoGridHeader tag={tag} heading={heading} description={description} leftAlignment={left_alignment} />

        {/* Cards Grid */}
        {isFilled.group(cards) && (
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {cards.map((card, index) => {
              const spanTwoColumns = card.columns === 2
              // Use a stable key based on card content or fallback to index
              const titleNode = isFilled.richText(card.title) ? card.title[0] : null
              const titleText = titleNode && typeof titleNode === 'object' && 'text' in titleNode ? titleNode.text : ''
              const key = titleText ? `${titleText}-${index}` : `card-${index}`

              return <BentoCard key={key} card={card} spanTwoColumns={spanTwoColumns} />
            })}
          </div>
        )}
      </div>
    </Container>
  )
}
